import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    supMainPageConfig: {}
  },
  getters: {
    supMainPageConfig: state => state.supMainPageConfig
  },
  mutations: {
    setI18n(state, payload) {
      state.supMainPageConfig  = payload
      console.log('store2', state.supMainPageConfig)
    }
  },
  actions: {
  }
})
